import React from 'react';
import Seo from '../config/seo';
import BaseLayout from '../layouts/BaseLayout';
import Home from '../components/pages/home';

const IndexPage = () => {
    return (
        <>
            <Seo
                title="The House Of Agency"
                description="Welcome to The House Of Agency"
            />
            <BaseLayout>
                <Home/>
            </BaseLayout>
        </>
    )
}

export default IndexPage;